import { CrmObjectTargetingConfigTypename } from 'personalization-lib/__generated__/chirp/com/hubspot/personalize/rpc/PersonalizeRpc';
import { CRM_TARGETING_KIND_TO_OBJECT_TYPE_ID, OBJECT_TYPE_ID_TO_CRM_TARGETING_KIND, TARGETING_KINDS } from 'personalization-lib/constants/targeting';

/**
 * `TargetingConfig` carries two discriminants, and neither is dependable: `type` is the Jackson
 * discriminator and is optional on the wire, and `__typename` is only added by the CHIRP Avro
 * gateway. Rather than discriminating on either, we key off `objectTypeAndId`, which only the CRM
 * object targeting config declares, so a CRM targeted variant resolves whichever discriminant its
 * response happens to carry.
 */
export const getCrmObjectTarget = targetingConfig => {
  const target = targetingConfig === null || targetingConfig === void 0 ? void 0 : targetingConfig.objectTypeAndId;
  return target !== null && target !== void 0 && target.objectTypeId && target.objectId != null ? target : undefined;
};
export const getCrmObjectTargets = variants => variants.map(variant => getCrmObjectTarget(variant.targetingConfig)).filter(target => Boolean(target));
export const isCrmTargetingKind = targetingKind => targetingKind === TARGETING_KINDS.CONTACT || targetingKind === TARGETING_KINDS.COMPANY;
export const getCrmObjectTypeId = targetingKind => CRM_TARGETING_KIND_TO_OBJECT_TYPE_ID[targetingKind];
export const buildCrmObjectTargetingConfig = objectTypeAndId => ({
  objectTypeAndId,
  __typename: CrmObjectTargetingConfigTypename
});
export const getCrmTargetingKind = targetingConfig => {
  const target = getCrmObjectTarget(targetingConfig);
  return target && OBJECT_TYPE_ID_TO_CRM_TARGETING_KIND[target.objectTypeId];
};